import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#2f3337',
    // #141414
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '1200px',
    },
    margin: '0 auto',
    // marginBottom: theme.spacing(4),
  },
  form: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.up(900)]: {
      maxHeight: '300px',
    },
  },
  white: {
    color: 'white',
  },
  formContainer: {
    backgroundColor: '#00c2cb',
    borderRadius: '20px',
    top: '-50px',
    padding: theme.spacing(4),
    position: 'relative',
    [theme.breakpoints.up(900)]: {
    },
    zIndex: 1,
  },
  formHeader: {
    fontSize: '32px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  horizontalFields: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  infusionFieldInput: {
    margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  button: {
    color: 'white',
    backgroundColor: '#f63c57',
    '&:hover': {
      backgroundColor: '#f52443',
    },
    '&:disabled': {
      backgroundColor: '#f86d82',
      color: 'white',
    },
    fontSize: '24px',
  },
  formSubtext: {
    fontSize: '12px',
    textAlign: 'center',
    marginBottom: theme.spacing(),
    paddingTop: theme.spacing(2),
  },
  link: {
    fontWeight: 'bold',
    textDecoration: 'none',
    color: 'white',
    '&visited': {
      textDecoration: 'none',
      color: 'white',
    },
  },
  bulletPoints: {
    fontSize: '22px',
  },
  headerContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down(960)]: {
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
    },
    [theme.breakpoints.down(600)]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
    },
  },
  header: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    fontSize: '32px',
    letterSpacing: '0.1em',
    fontWeight: 'bold',
  },
  red: {
    color: '#f63c57',
  },
  spacer: {
    height: 60,
    backgroundColor: 'white',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});

class NiaDayGuideSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inf_field_FirstName: '',
      inf_field_Email: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }


  render() {
    const { classes } = this.props;

    const {
      inf_field_FirstName,
      inf_field_Email,
    } = this.state;

    function canSubmit() {
      if (inf_field_FirstName !== '' && inf_field_Email !== '') {
        return true;
      }
      return false;
    }

    return (
      <div className={classes.section}>
        <div className={classes.content}>
          <Grid container>
            {/* Header Section */}
            <Grid item xs={12} md={5} className={classNames(classes.form, classes.white)}>
              <Flip right>
                <div className={classes.formContainer}>
                  {/* Form Section */}
                  <Typography variant="h2" className={classes.formHeader}>
                    Get your&nbsp;
                    <span className={classes.uppercase}>free</span>
                    <br />
                    &nbsp;&apos;Nia Day&apos; Guide
                  </Typography>
                  <form acceptCharset="UTF-8" action="https://sp877.infusionsoft.com/app/form/process/a0a8138a92ba7e33fec4ab7c51d5389f" className={classes.infusionForm} id="inf_form_a0a8138a92ba7e33fec4ab7c51d5389f" method="POST">
                    <input name="inf_form_xid" type="hidden" value="a0a8138a92ba7e33fec4ab7c51d5389f" />
                    <input name="inf_form_name" type="hidden" value="Nia Day PDF Request~br~Web Form Submitted" />
                    <input name="infusionsoft_version" type="hidden" value="1.70.0.426972" />
                    <div className={classes.horizontalFields}>
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_FirstName"
                        name="inf_field_FirstName"
                        placeholder="First Name *"
                        type="text"
                        variant="outlined"
                        value={inf_field_FirstName}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                      <TextField
                        required
                        className={classes.infusionFieldInput}
                        id="inf_field_Email"
                        name="inf_field_Email"
                        placeholder="Email *"
                        type="text"
                        variant="outlined"
                        value={inf_field_Email}
                        onChange={this.handleChange}
                        inputProps={{ style: { fontSize: '18px' } }}
                      />
                    </div>
                    <div className={classes.buttonContainer}>
                      <Button disabled={!canSubmit()} color="secondary" variant="outlined" size="large" className={classNames(classes.button, 'infusion-recaptcha')} id="recaptcha_a0a8138a92ba7e33fec4ab7c51d5389f" type="submit">SUBMIT</Button>
                    </div>
                  </form>
                  <script type="text/javascript" src="https://sp877.infusionsoft.app/app/webTracking/getTrackingCode" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=1.70.0.426972-hf-202201191855" />
                  <script src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit" async="async" defer="defer" />
                  <script type="text/javascript" src="https://sp877.infusionsoft.com/app/timezone/timezoneInputJs?xid=a0a8138a92ba7e33fec4ab7c51d5389f" />
                  <Typography className={classes.formSubtext}>
                    By signing up your agree to Nia&apos;s&nbsp;
                    <a className={classes.link} href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                    &nbsp;and&nbsp;
                    <a className={classes.link} href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    &nbsp;and opt-in to receive email communications from Nia
                  </Typography>
                </div>
              </Flip>
            </Grid>
            <Grid item xs={12} md={7} className={classes.headerContent}>
              <Fade right>
                <Typography variant="h1" className={classNames(classes.header, classes.uppercase, classes.white)}>
                  Get your&nbsp;
                  <span className={classes.red}>free checklist + guide</span>
                </Typography>
              </Fade>
              <ul className={classNames(classes.bulletPoints, classes.white)}>
                <Fade right>
                  <li>
                    <p>
                      <strong>8 simple steps </strong>
                      to feel better body, mind + spirit
                    </p>
                  </li>
                </Fade>
                <Fade right>
                  <li>
                    <p>
                      <strong>Tips to make movement and mindfulness </strong>
                      a part of your daily routine
                    </p>
                  </li>
                </Fade>
                <Fade right>
                  <li>
                    <p>
                      <strong>Easy-to-follow checklist </strong>
                      to help you build new healthy habits
                    </p>
                  </li>
                </Fade>
              </ul>
              {/*<img src={FeelBetterText} className={classes.feelBetterText} alt="the words feel better in cursive" />*/}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

NiaDayGuideSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NiaDayGuideSection);
